/**
 * Created by stonewang on 2017/8/15.
 */
const apiHead = [
    'http://36.22.191.179:8180', //0 -- 测试环境打包地址
    'https://dmc.tengen.com.cn', //1 -- 生产环境打包地址
    'http://116.62.205.172', //2 -- 公网IP APP1
    'http://47.96.170.196', //3 -- 公网IP APP2
    'http://192.168.77.194:8080', //4 -- 汤兴杰
    'http://10.132.100.158:8080', //5 -- 汤兴杰
];

const index = 1;
const server = apiHead[index] + '/xweb';
const mxm = apiHead[index] + '/mxm';
window.localStorage.setItem('server', server);

const config = {
    name: 'DMS管理平台',
    server: server,
    mxm: mxm,
    h5Root: '/home',
    '配件类编码': '351', // 配件类编码
    index: index
};
export {config as default}



// WEBPACK FOOTER //
// ./src/utils/config.js